import React from 'react';
import Typography from '../Typography/Typography';
import FilterRequireIcon from '../../Icons/FilterRequireIcon';
import SvgMobileFilterRequest from '../../Icons/MobileFilterRequire';
import styles from './FilterRequire.module.css';

/**
 * @typedef {Object} FilterRequireProps
 * @property {string} [type] - Entity type shown in the default message (e.g. "unit", "site")
 * @property {string} [text] - Custom message overriding the default filter prompt
 * @property {boolean} [expand=false] - If true, stretches the container to fill its parent (100% width/height)
 * @property {boolean} [mobile=false] - If true, applies mobile layout (full size, top-aligned, smaller text)
 * @property {React.ReactNode} [icon] - Icon or illustration rendered in the upper half
 */

/**
 * Empty-state component prompting the user to apply filters before content is shown.
 * Supports both desktop and mobile layouts via the `mobile` prop.
 *
 * @param {FilterRequireProps} props
 * @returns {React.ReactElement}
 */
const FilterRequire = ({ type, text, expand = false, mobile = false, icon = <FilterRequireIcon /> }) => {
  const containerClass = [
    styles.container,
    'filter-require-container',
    expand && styles.expand,
    mobile && styles.mobile,
  ].filter(Boolean).join(' ');

  const message = text || `Please select a ${type} using the filters at the top of the page`;

  const renderedIcon = mobile ? <SvgMobileFilterRequest /> : icon;

  return (
    <div className={containerClass}>
      {renderedIcon && (
        <div className={mobile ? styles.imageContainerMobile : styles.imageContainer}>
          {renderedIcon}
        </div>
      )}
      <div className={styles.textContainer}>
        <Typography className={mobile ? styles.textMobile : styles.text} align="center">
          {message}
        </Typography>
      </div>
    </div>
  );
};

export default FilterRequire;
